
















































































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import ProvisionRquestsInjectorMixin from "@/mixins/provisionRequestsInjectorMixin";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IProvisionRequest } from "@/models/provisioning";
import { IQuickAction } from "@/models/actions";

@Component({
  components: {
    "provision-request-row-item": () =>
      import("@/components/app/admin/provisioning/provisionRequestRowItem.vue")
  }
})
export default class ProvisionRequestsTableView extends Mixins(
  ProvisionRquestsInjectorMixin
) {
  // Data

  public isRetrying = {};

  // Methods

  public availableActions(request: IProvisionRequest) {
    return this.$_.filter(this.actions(request), action => action.if);
  }

  public actions(request: IProvisionRequest): IQuickAction[] {
    return [
      // View
      {
        label: this.$t("_action.view_request"),
        method: () => this.$requestsMethods.viewRequest(request.id),
        icon: "info",
        if: true
      },
      // Resolve
      {
        label: this.$t("_action.mark_resolved"),
        method: () => this.resolveRequest(request),
        icon: "check",
        if: this.canResolve(request)
      },
      // Retry
      {
        label: this.$t("_action.retry_request"),
        method: () => this.retryRequest(request),
        icon: this.isRetrying[request.id] ? "circle-notch" : "redo",
        actionClass: this.isRetrying[request.id]
          ? "is-processing is-icon-spinning"
          : undefined,
        if: this.canRetry(request)
      },
      // Cancel
      {
        label: this.$t("_action.cancel_request"),
        method: () => this.cancelRequest(request),
        icon: "times-circle",
        actionClass: "has-text-danger",
        if: this.canCancel(request)
      }
    ];
  }

  public canResolve(request: IProvisionRequest) {
    return this.$store.getters[
      `data/${DataModules.PROVISIONING_REQUESTS}/canResolve`
    ](request);
  }

  public canRetry(request: IProvisionRequest) {
    return this.$store.getters[
      `data/${DataModules.PROVISIONING_REQUESTS}/canRetry`
    ](request);
  }

  public canCancel(request: IProvisionRequest) {
    return this.$store.getters[
      `data/${DataModules.PROVISIONING_REQUESTS}/canCancel`
    ](request);
  }

  public async resolveRequest({ id }: IProvisionRequest) {
    this.toogleDropdown(id);

    try {
      await this.$store.dispatch(
        `data/${DataModules.PROVISIONING_REQUESTS}/resolveRequest`,
        { id }
      );

      this.$store.dispatch("toast/show", {
        message: this.$t("_.request_marked_resolved")
      });

      this.$requestsMethods.reloadData();
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
  }

  public retryRequest({ id }: IProvisionRequest) {
    if (this.isRetrying[id]) return;

    this.$set(this.isRetrying, id, true);

    this.$store.dispatch(
      `data/${DataModules.PROVISIONING_REQUESTS}/retryProvisionRequest`,
      {
        id,
        onSuccess: newRequest => {
          this.$requestsMethods.viewRequest(newRequest.id);
          this.$requestsMethods.reloadData();
          this.$store.dispatch("toast/show", {
            message: this.$t("_.request_successfully_resent")
          });
        },
        onFinish: () => {
          this.$set(this.isRetrying, id, undefined);
          this.toogleDropdown(id);
        }
      }
    );
  }

  public cancelRequest({ id }: IProvisionRequest) {
    this.toogleDropdown(id);

    this.$store.dispatch(
      `data/${DataModules.PROVISIONING_CONTRACT_PRODUCTS}/openCancelRequestModal`,
      {
        requestId: id,
        onSuccess: this.$requestsMethods.reloadData
      }
    );
  }

  public toogleDropdown(requestId: IProvisionRequest["id"]) {
    // @ts-ignore
    this.$refs[`requestControlDropdown_${requestId}`][0]?.toggle();
  }

  public handleClick(requestId) {
    if (this.showSkeletons) return;
    this.$requestsMethods.viewRequest(requestId);
  }

  // Computed

  public get skeletonSize() {
    return this.$store.getters["ui/isMobile"] ? 2 : 5;
  }

  public get showEmptyState() {
    return !this.$requestsData.isLoading && !this.$requestsData.total;
  }

  public get showSkeletons() {
    return (
      this.$requestsData.table.loading ||
      this.$requestsData.isLoading ||
      !this.$requestsData.total
    );
  }

  public get showContractProduct() {
    return !this.$requestsData.productId;
  }
}
